module.exports = __webpack_public_path__ + "img/组 6@2xmob.eae9f88e.png";